// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* region INPUT */
:where(.vuetify-styles) .v-color-input {
  padding: 0;
}
:where(.vuetify-styles) .v-color-input.v-input--density-default .v-color-input__pip {
  --v-avatar-height: 40px;
}

:where(.vuetify-styles) .v-color-input.v-input--density-comfortable .v-color-input__pip {
  --v-avatar-height: 32px;
}

:where(.vuetify-styles) .v-color-input.v-input--density-compact .v-color-input__pip {
  --v-avatar-height: 28px;
}

:where(.vuetify-styles) .v-color-input .v-color-input__pip.v-avatar--variant-text {
  --v-avatar-height: min-content;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VColorInput/VColorInput.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* region INPUT */\n.v-color-input {\n  padding: 0;\n}\n.v-color-input.v-input--density-default .v-color-input__pip {\n  --v-avatar-height: 40px;\n}\n\n.v-color-input.v-input--density-comfortable .v-color-input__pip {\n  --v-avatar-height: 32px;\n}\n\n.v-color-input.v-input--density-compact .v-color-input__pip {\n  --v-avatar-height: 28px;\n}\n\n.v-color-input .v-color-input__pip.v-avatar--variant-text {\n  --v-avatar-height: min-content;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
